import { render, staticRenderFns } from "./RelationOverview.vue?vue&type=template&id=3faf2af2&scoped=true"
import script from "./RelationOverview.vue?vue&type=script&lang=js"
export * from "./RelationOverview.vue?vue&type=script&lang=js"
import style0 from "./RelationOverview.vue?vue&type=style&index=0&id=3faf2af2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3faf2af2",
  null
  
)

export default component.exports